export default {
  // 侧边栏
  sidebar: state => state.app.sidebar,
  // token
  token: state => state.MerchantAuth.accessToken,
  username: state => state.MerchantAuth.username,
  adminId: state => state.MerchantAuth.adminId,
  // deviceId
  deviceId: state => state.app.deviceId,
  menus: state => state.MerchantMe.menus,
  permissions: state => state.MerchantMe.permissions,
  role: state => state.MerchantMe.role,
  merchantInfo: state => state.MerchantMe.merchantInfo,
  // 公共存储路径
  publicDataHost: state => state.MerchantOssUpload.publicDataHost
}



// WEBPACK FOOTER //
// ./src/store/getters.js